import React from 'react';
import emailjs from 'emailjs-com';
import './Contact.css';
import { FaFacebookF, FaLinkedinIn, FaGithub, FaInstagram, FaTwitter, FaMapMarkerAlt, FaMobileAlt, FaEnvelope, FaStackOverflow } from 'react-icons/fa';
import { sendEmail } from './Firebase.Config';
import ParticlesBg from 'particles-bg';


const Contact = () => {

    

    return (
        <>
        <div className="container">
            <h1>Get in Touch</h1>
            <div className="row">

                <div className="col-md-5 contactStyle" >

                    <div data-aos="fade-left" data-aos-delay="20" data-aos-duration="1000" data-aos-easing="ease-in-sine">
                        <img src="https://i.ibb.co/XVmKVhX/passport-size-logo.png" alt="" fluid  />
                        <div className="my-3">
                            <p className='my-2'>If you have any query feel free to contact me</p>
                            <h6 className='my-2'><FaMapMarkerAlt /> Narsingdi, Bangladesh</h6>
                            <h6 className='my-2'><FaMobileAlt /> +88 01921 652823</h6>
                            <h6 className='my-2'><FaEnvelope /> sakib14april@gmail.com</h6>
                        </div>

                        <div className="m-2  my-4">
                            <a href="https://www.facebook.com/sakib752" target="_blank" className='mx-2' rel="noreferrer noopener">
                                <FaFacebookF size='2rem' />
                            </a>
                            <a href="https://www.linkedin.com/in/nazmus-sakib-developer/" target="_blank" className='mx-2' rel="noopener noreferrer">
                                <FaLinkedinIn size='2rem' />
                            </a>
                            <a href="https://github.com/saakeeb" target="_blank" className='mx-2' rel="noopener noreferrer">
                                <FaGithub size='2rem' />
                            </a>
                            <a href="https://www.instagram.com/n_saakeeb/" target="_blank" className='mx-2' rel="noopener noreferrer">
                                <FaInstagram size='2rem' />
                            </a>
                            <a href="https://twitter.com/Saakeeb" target="_blank" className='mx-2' rel="noopener noreferrer">
                                <FaTwitter size='2rem' />
                            </a>
                            <a href="https://stackoverflow.com/users/12980133/nazmus-sakib" target="_blank" className='mx-2' rel="noopener noreferrer">
                                <FaStackOverflow size='2rem' />
                            </a>
                        </div>
                    </div>
                </div>


                <div className="col-md-7">
                    <form className="contact-form mailStyle" onSubmit={sendEmail}>
                        <div className="col-md-8 form-group">
                            <input type="text" name="name" className="form-control mx-6 my-2 p-6" placeholder="Your Name" required />
                        </div>
                        <div className="col-md-8 form-group">
                            <input type="email" name="email" className="form-control mx-6 my-2" placeholder="Your Mail" required />
                        </div>
                        <div className="col-md-8 form-group">
                            <input type="text" name="subject" className="form-control mx-6 my-2" placeholder="Subject" required />
                        </div>
                        <div className="col-md-8 form-group">
                            <textarea name="message" rows="6" cols="7" className="form-control mx-6 my-2" placeholder="Your Message" required />
                            <input type="submit" value="Send Message" className="m-2 btn btn-primary" />
                        </div>

                    </form>
                </div>
            </div>

        </div>
        <ParticlesBg num={20} type="cobweb" bg={true} />
        </>
    );
};

export default Contact;